import { getKeys as m } from "./types3.mjs";
import s from "./tokens.json.mjs";
import { makeShadowStyleFromToken as a } from "./utils8.mjs";
const n = s.brand, l = (o) => o.reduce((e, t, r) => (e += a(t), r < o.length - 1 && (e += ","), e), ""), u = () => {
  const o = m(n.elevation);
  return ["none"].concat(
    o.map((e) => {
      const t = n.elevation[e].value;
      return l(t);
    })
  );
};
export {
  u as compileElevation
};
//# sourceMappingURL=compileElevation.mjs.map
